import { PrefixedUnion, createMediaPropertyMap } from './mediaProperties'
import { resolveSizeValues } from './resolveSizeValues'
import { Size } from './size'

const marginPropKeys = ['m', 'mt', 'mr', 'mb', 'ml'] as const
type MarginKeyProps = (typeof marginPropKeys)[number]

const marginPropsCssMap: Record<MarginKeyProps, string> = {
  ['m']: 'margin',
  ['mt']: 'margin-top',
  ['mr']: 'margin-right',
  ['mb']: 'margin-bottom',
  ['ml']: 'margin-left'
}

type MarginMediaKeys = MarginKeyProps | PrefixedUnion<'sm', MarginKeyProps>

export type MarginProps = Partial<Record<MarginMediaKeys, number | Size>>

export const margin = (props: MarginProps) => resolveSizeValues(props, marginPropsCssMap)
export const smMargin = (props: MarginProps) =>
  resolveSizeValues(props, createMediaPropertyMap(marginPropsCssMap, 'sm'))
